import axiosInstance from "../../../api/axiosInstance";

let putUser = async(form) => {
    return new Promise((resolve, reject) => {   
        axiosInstance.put(process.env.REACT_APP_API + "/users/update", form).then(response=> {
            resolve(response.data);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

export default putUser